export const leagueColor: Leagues.Color[] = [
  {
    name: 'Amethyst',
    value: '#916aa0',
  },
  {
    name: 'Turquoise',
    value: '#089f9f',
  },
  {
    name: 'Peridot',
    value: '#82bf71',
  },
  {
    name: 'Amber',
    value: '#e0b951',
  },
  {
    name: 'Coral',
    value: '#d88f8d',
  },
  {
    name: 'Ruby',
    value: '#9c3649',
  },
  {
    name: 'Red',
    value: '#e74c3c',
  },
  {
    name: 'Blue',
    value: '#3498db',
  },
  {
    name: 'Orange',
    value: '#d35400',
  },
  {
    name: 'Yellow',
    value: '#f1c40f',
  },
  {
    name: 'Green',
    value: '#27ae60',
  },
  {
    name: 'Turquoise',
    value: '#16a085',
  },
  {
    name: 'MidNight Blue',
    value: '#2c3e50',
  },
  {
    name: 'Magenta',
    value: '#9b59b6',
  }
];

export const leaguePeriod: Base.KeyLabelModel[] = [
  {
    key: 'DAILY',
    label: 'Daily'
  },
  {
    key: 'WEEKLY',
    label: 'Weekly'
  },
  {
    key: 'BI_WEEKLY',
    label: 'Bi Weekly'
  },
  {
    key: 'MONTHLY',
    label: 'Monthly'
  }
];

